// src/redux/appointmentsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from './actions/api';


export const updateAppointment = createAsyncThunk(
  'appointments/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      // POST + method-override instead of a real PUT: IIS/WebDAV blocks PUT with a 405 before PHP.
      const res = await axios.post(`${API_URL}visitors/${id}`, formData, {
        headers: { 'X-Http-Method-Override': 'PUT' },
      });
      if (res.data.data && res.data.data.error) {
        return rejectWithValue(res.data.data.error);
      }
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.title) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue('Server error');
    }
  }
);

const appointmentsSlice = createSlice({
  name: 'appointments',
  initialState: {
    visitors: [],
    loading: false,
    error: null,
  },
  reducers: {
    // Define other synchronous actions if needed
  },
  extraReducers: (builder) => {
    builder.addCase(updateAppointment.fulfilled, (state, action) => {
      const index = state.visitors.findIndex(
        (visitor) => visitor.id === action.payload.id
      );
      if (index !== -1) {
        // Replace the old appointment with the updated one
        state.visitors[index] = action.payload;
      }
    });
    builder.addCase(updateAppointment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateAppointment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default appointmentsSlice.reducer;
